module.exports = "<div class=\"card\">\r\n    <div class=\"card-body\">\r\n        <spk-search-grid [list]=\"'SearchTestSearchRow'\" title=\"Searches\" autoload=\"true\" defaultSortProperty=\"Name ASC, AddDate DESC\" showSearch=\"true\" [leftLinks]=\"leftLinks\"\r\n            [rightLinks]=\"rightLinks\" [headerLinks]=\"headerLinks\" [filter]=\"filter\" [csvExport]=\"false\" [cardView]=\"true\"></spk-search-grid>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/search-tests/search-tests.component.html
// module id = ./src/app/components/examples/search-tests/search-tests.component.html
// module chunks = main